const images = [];

export default function (url) {
  if (url && !images[url]) {
    images[url] = new Image();
    images[url].src = url;
  }
}
